export const RecommendationKind = {
  Action: 'action',
  Collaboration: 'collaboration',
} as const;

export type RecommendationKindType = (typeof RecommendationKind)[keyof typeof RecommendationKind];
